import type { ReactElement } from "react";
import { BooleanField, Datagrid, FunctionField, TextField } from "react-admin";
import { useMediaQuery } from "@mui/material";
import type { Theme } from "@mui/material";
import { useNavigate } from "react-router";
import { Column } from "../../misc/Column";
import type { DrivingSchoolAutoForm } from "../../providers/autoFormsProvider";
import { AutoFormMobileListItem } from "./AutoFormMobileListItem";

export function AutoFormsDataGrid(props: {
  autoForms: DrivingSchoolAutoForm[];
  empty?: ReactElement;
  isEditable?: boolean;
  showRegistrationStatus?: boolean;
}) {
  const { autoForms, empty, isEditable = false, showRegistrationStatus = false } = props;
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const rowClick = isEditable ? "edit" : false;

  if (isMobile) {
    if (autoForms.length === 0) {
      return empty ?? null;
    }

    return (
      <Column sx={{ gap: 1, py: "1px" }}>
        {autoForms.map((autoForm) => (
          <AutoFormMobileListItem
            key={autoForm.id}
            autoForm={autoForm}
            onClick={isEditable ? () => navigate(`/autoForms/${autoForm.id}`) : undefined}
            showRegistrationStatus={showRegistrationStatus}
          />
        ))}
      </Column>
    );
  }

  return (
    <Datagrid
      resource="autoForms"
      rowClick={rowClick}
      sort={{ field: "name", order: "ASC" }}
      bulkActionButtons={false}
      data={autoForms}
      empty={empty}
    >
      <TextField label="Titel" source="name" />
      <TextField label="Beschreibung" source="description" emptyText="—" />
      <FunctionField
        label="PDF-Vorlage"
        sortable={false}
        render={(record: DrivingSchoolAutoForm) => record.pdfTemplateBaseFile.fileName}
      />
      {showRegistrationStatus && <BooleanField label="Bei Anmeldung ausfüllen" source="isForRegistration" looseValue />}
    </Datagrid>
  );
}
